var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactIconFactory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3L18.0181 15H17.25L12.75 9L12 15L7.5 9L6.75 15L2.25 9L1.5 15V22.5H22.5V3H21V15H19.5V3H18ZM3 16.5H5.25V18H3V16.5ZM6.75 16.5H9V18H6.75V16.5ZM10.5 16.5H12.75V18H10.5V16.5ZM14.25 16.5H16.5V18H14.25V16.5ZM3 19.5H5.25V21H3V19.5ZM6.75 19.5H9V21H6.75V19.5ZM10.5 19.5H12.75V21H10.5V19.5ZM14.25 19.5H16.5V21H14.25V19.5Z",
    fill: "#A68BF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIconFactory);
export default __webpack_public_path__ + "static/media/react-icon-factory.ae243cdc9847548f344e0e9842b9a9a2.svg";
export { ForwardRef as ReactComponent };